import axios from 'axios';
// import vuexStore from '@/store';
// import router from '@/router';

var api = axios.create({
  baseURL: process.env.MIX_BASE_URL_PREFIX,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    // 'Content-Type': 'multipart/form-data',
    'Api-Token': getApiToken(),
    'auth-token': getApiToken(true),
    // 'User-ID': this.$currentUID
  }
});

// api.interceptors.response.use(
//   async resp => resp,
//   async err => {
//     if (err.response.data.message === 'Unauthenticated.') {
//       await vuexStore.dispatch('auth/logout');
//       router.push('login');
//     }
//     return Promise.reject(err);
//   }
// );

const index = async (resource) => {
  updateToken();
  return await api.get(resource);
}
const show = async (resource, id = null) => {
  updateToken();
  return await api.get(`${resource}/${id}`);
}
const store = async (resource, data) => {
  updateToken();
  return await api.post(resource, data).then((r) => {
    return r;
  }).catch((e) => {
    return {
      data: {
        success: false,
        response: e?.response?.data,
        message: e?.response?.data?.message + "\n" + e?.response?.data?.file + "\n" + e?.response?.data?.line
      }
    }
  })
}
const post = async (resource, data, formData = false) => {
  updateToken(formData);
  return await api.post(resource, data).then((r) => {
    return r;
  }).catch((e) => {
    return {
      data: {
        success: false,
        response: e?.response?.data,
        message: e?.response?.data?.message + "\n" + e?.response?.data?.file + "\n" + e?.response?.data?.line
      }
    }
  })
  // return await api.post(resource, data);
}
const update = async (resource, id, data) => {
  updateToken();
  return await api.put(`${resource}/${id}`, data);
}
const destroy = async (resource, id) => {
  updateToken();
  return await api.delete(`${resource}/${id}`);
}

function updateToken(formData = false) {
  let headers = {
    'Content-Type': 'application/json',
    'Api-Token': getApiToken()
  };
  if (formData) {
    headers['Content-Type'] = 'multipart/form-data';
  }
  if (formData || !api.defaults.headers.common['Api-Token']) {
    api = axios.create({
      baseURL: process.env.MIX_BASE_URL_PREFIX,
      withCredentials: true,
      headers: headers
    });
  }
};

export default {
  index,
  show,
  store,
  post,
  update,
  destroy,
  updateToken
};

function getApiToken(authToken = false) {
  // console.log(localStorage);
  // let response = await axios.get('/api/auth/getToken')
  // console.log(localStorage.getItem('api-token'));
  // console.log(localStorage['api-token']);
  // console.log(localStorage['auth.token']);
  return authToken ? localStorage['auth.token'] : localStorage['api-token'];
}
